import { HorizontalCardGroup } from '@ps/isp-web-component-library';
import React from 'react';
import { useSelector } from 'react-redux';

import type { SportsHomePageWidgetModel } from 'widgets/sports-home-page-widget/model';
import type { ExtractSelectFromModel, RootState } from '@swf/core/store';
import { OddsBoostPanelHeader, SportsComponent } from '@swf/sports/components';

import styles from './OddsBoostEvents.scss';
import OddsBoostEventCard from './components/OddsBoostEventCard/OddsBoostEventCard';

interface Props {
  widgetSelect: Pick<
    ExtractSelectFromModel<SportsHomePageWidgetModel>,
    'oddsBoostEvents' | 'hasOddsBoostEvents'
  >;
}

export const OddsBoostEvents: React.FC<Props> = ({ widgetSelect }) => {
  const hasOddsBoostEvents = useSelector((state: RootState) =>
    widgetSelect.hasOddsBoostEvents(state)
  );

  const oddsBoostEvents = useSelector((state: RootState) => widgetSelect.oddsBoostEvents(state));

  if (!hasOddsBoostEvents) return null;
  return (
    <SportsComponent name="Sports Popular Odds Boost Events Component">
      <OddsBoostPanelHeader />
      <HorizontalCardGroup className={styles.cardGroup}>
        {oddsBoostEvents.map((oddsBoostItem) =>
          oddsBoostItem.template.templateId === 'ODDS_BOOST' ? (
            <OddsBoostEventCard
              key={`${oddsBoostItem.template.marketId}-${oddsBoostItem.template.templateId}`}
              marketId={oddsBoostItem.template.marketId}
            />
          ) : null
        )}
      </HorizontalCardGroup>
    </SportsComponent>
  );
};
